var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.current_acount)?_c('b-modal',{attrs:{"title":"Cheques","hide-footer":"","id":"checks-details"}},_vm._l((_vm.current_acount.checks),function(check){return _c('check-component',{attrs:{"disabled_inputs":true,"check":check}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }